module.exports = __webpack_public_path__ + "static/media/suber5.7dabd3fc.png";